import { render, staticRenderFns } from "./EntregaLista.vue?vue&type=template&id=44b397a8&scoped=true"
import script from "./EntregaLista.vue?vue&type=script&lang=js"
export * from "./EntregaLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b397a8",
  null
  
)

export default component.exports